import React from 'react'
import { Badge } from '@/components/ui/badge'

// The promo an order was given ({name, percentage, free_month} from the API), whose discount is
// already in the price shown
export function promoSummary(promo) {
  const terms = []

  if (promo.percentage > 0) {
    terms.push(`${promo.percentage}% off`)
  }

  if (promo.free_month) {
    terms.push('first month free')
  }

  return `${promo.name} promotion: ${terms.join(', ')}`
}

export default function PromoBadge({ promo, className = '' }) {
  if (!promo) {
    return null
  }

  return (
    <Badge variant="info" className={`h-auto whitespace-normal ${className}`}>
      {promoSummary(promo)}
    </Badge>
  )
}
